import React, { useState, useCallback, useMemo, useEffect } from 'react'
import { useTranslations } from 'next-intl'
import { TableConverterProps } from '@/lib/table/types'
import { parseInput, convertOutput } from '@/lib/table/converter'
import { TableInput } from './table-input'
import { TableOutput } from './table-output'

// 示例数据
const EXAMPLE_DATA = {
  markdown: '| 姓名 | 年龄 | 城市 |\n| --- | --- | --- |\n| 张三 | 28 | 北京 |\n| 李四 | 32 | 上海 |\n| 王五 | 25 | 广州 |',
  csv: '姓名,年龄,城市\n张三,28,北京\n李四,32,上海\n王五,25,广州',
  json: JSON.stringify([
    { "姓名": "张三", "年龄": "28", "城市": "北京" },
    { "姓名": "李四", "年龄": "32", "城市": "上海" },
    { "姓名": "王五", "年龄": "25", "城市": "广州" }
  ], null, 2)
}

export function TableConverter({ defaultInputFormat = 'markdown', defaultOutputFormat = 'csv' }: TableConverterProps) {
  const t = useTranslations('MarkdownTable')
  const [input, setInput] = useState(EXAMPLE_DATA[defaultInputFormat] || EXAMPLE_DATA.markdown)
  const [inputFormat, setInputFormat] = useState(defaultInputFormat)
  const [outputFormat, setOutputFormat] = useState(defaultOutputFormat)
  const [jsonOutputFormat, setJsonOutputFormat] = useState<'array' | 'object'>('object')

  // 处理输入格式变化
  const handleInputFormatChange = useCallback((value: typeof inputFormat) => {
    setInputFormat(value)
    
    // 根据新的输入格式提供示例数据
    setInput(EXAMPLE_DATA[value] || EXAMPLE_DATA.markdown)
  }, [])

  // 转换输出
  const output = useMemo(() => {
    try {
      const data = parseInput(input, inputFormat)
      if (!data.length) {
        return t('conversionError')
      }
      return convertOutput(data, outputFormat, jsonOutputFormat)
    } catch (error) {
      console.error('转换失败:', error)
      return t('conversionError')
    }
  }, [input, inputFormat, outputFormat, jsonOutputFormat, t])

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 mt-4">
      <TableInput
        value={input}
        onChange={setInput}
        format={inputFormat}
        onFormatChange={handleInputFormatChange}
      />
      
      <TableOutput
        value={output}
        format={outputFormat}
        onFormatChange={setOutputFormat}
        jsonFormat={jsonOutputFormat}
        onJsonFormatChange={setJsonOutputFormat}
      />
    </div>
  )
} 